import api from '../../../utils/api';
import { alertError } from '../alert';
import { SHOPIFY_CUSTOMER_ID } from '../../constants/shopifyTypes';

export const createShopifyAccount = (customerName, warehouseId) => async (dispatch) => {
  try {
    const res = await api.post(
      '/shopify/manageCustomers',
      { first_name: customerName },
      { params: { warehouse_id: warehouseId } },
    );
    if (res.data.success) {
      const shopifyCustomerAccountId = res.data.customerId.toString();
      dispatch({ type: SHOPIFY_CUSTOMER_ID, payload: { shopifyCustomerAccountId } });
    } else dispatch(alertError('Failed to create a Shopify account'));
  } catch (e) {
    dispatch(alertError(e));
  }
};
